module.exports = __webpack_public_path__ + "static/media/port.6396f3be.svg";